import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumberFromString from 'libphonenumber-js';

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform(phone: string): string {
    if (!phone) return '';

     try {
      // Adiciona +351 se não tiver DDI
      const completePhone = phone.startsWith('+') ? phone : `+351${phone}`;

      const phoneNumber = parsePhoneNumberFromString(completePhone);

      if (phoneNumber && phoneNumber.isValid()) {
        // Se for de Portugal, retorna com +351 e formatação local
        if (phoneNumber.country === 'PT') {
          return `+351 ${phoneNumber.formatNational()}`; // Ex: +351 912 345 678
        }

        // Para outros países, usa o formato internacional
        return phoneNumber.formatInternational();
      }

      return phone; // Se for inválido, retorna original
    } catch (error) {
      console.warn('❌ Número inválido:', phone);
      return phone;
    }
  }


}
